import React from 'react';
import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'

import Config from "composer/Config.jsx"
import Localization from "composer/Localization.jsx"
import LocaleViewerPage from "composer/pages/LocaleViewerPage.jsx"
import { Badge } from '@material-ui/core';
import { Icon, Tooltip, IconButton, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, Grid, FormControl, Select, MenuItem } from '@material-ui/core';
import { Card, CardMedia, CardContent, CardActionArea, CardActions, Typography, Divider } from '@material-ui/core';
import {
  blue,
  green,
  amber,
  red,
} from '@material-ui/core/colors/'
import BackgroundImage from 'composer/images/background/test.png';
const styles = {
  card: {
    minHeight: 420,
  },
  media: {
    height: 240,
  },
  actions: {
    display: 'flex',
  },
};

class LocaleListView extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    this.state = {
    };
    autoBind(this);
  }

  overviewLocaleClicked(index) {
    // console.log('on overview clicked');
    this.props.parent.overviewLocale(index);
  }

  editLocaleClicked(index) {
    console.log("editLocaleClicked");
    this.props.parent.editLocaleByIndex(index);
  }

  exploreLocaleClicked(index) {
    let locale = this.props.parent.state.localeList[index];
    let position = {
      lat: parseFloat(locale.mid_lat),
      lng: parseFloat(locale.mid_lon)
    };
    this.props.parent.state.localeListInMap = [];
    this.props.parent.state.localeListInMap.push(locale);
    this.props.parent.changeView(LocaleViewerPage.VIEW_LOCALE_MAP());
    this.props.parent.setLocaleCenter(position);
  }

  infoLocaleClicked(index) {
    this.props.parent.showLocaleInfo(index);
  }

  retrieveAnswerClicked(index) {
    this.props.parent.retrieveAnswerByIndex(index);
  }

  deleteLocaleClicked(id) {
    this.props.parent.deleteLocale(id);
  }

  previousPageClicked() {
    this.props.parent.previousPage();
  }

  nextPageClicked() {
    this.props.parent.nextPage();
  }

  pageChanged(e) {
    this.props.parent.changePage(e.target.value);
  }

  pageNavigator() {
    let pages = [];
    for (let i = 0; i < this.props.parent.state.totalPage; i++) {
      pages.push(i);
    }
    return [
      <div key="page" style={{padding:'0 12px 0 0', display:'inline-block'}}>{Localization.strings.PAGE}</div>,
      <FormControl key="currentPage" margin='dense'>
        <Select style={{paddingLeft:"15px"}}
          value={this.props.parent.state.currentPage}
          onChange={this.pageChanged}
        >
          {
            pages.map( (page, i) => {
              return (
                <MenuItem key={i} value={i}>{i+1}</MenuItem>
              )
            })
          }
        </Select>
      </FormControl>,
      <Tooltip key="previousPage"
        title={Localization.strings.PREVIOUS_PAGE}
        placement="bottom"
      >
        <span>
          <IconButton
            onClick={this.previousPageClicked}
            disabled={this.props.parent.state.currentPage <= 0}
          >
            <Icon>keyboard_arrow_left</Icon>
          </IconButton>
        </span>
      </Tooltip>,
      <Tooltip key="nextPage"
        title={Localization.strings.NEXT_PAGE}
        placement="bottom"
      >
        <span>
          <IconButton
            onClick={this.nextPageClicked}
            disabled={this.props.parent.state.currentPage + 1 >= this.props.parent.state.totalPage}
          >
            <Icon>keyboard_arrow_right</Icon>
          </IconButton>
        </span>
      </Tooltip>
    ];
  }

  render() {
    let isAdminUser = this.props.root.isAdminUser();
    return (
      <div>
        <If condition={this.props.parent.state.localeList.length == 0}>
          <Then>
          <div style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
              <img style={{position: 'absolute',top: '55%',left: '50%',transform: 'translate(-50%,-50%)',height:'55%',width:'auto'}} src={BackgroundImage} />
            </div>
            <div style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
              <Card style={{position: 'absolute',top: '84%',left: '50%',transform: 'translate(-50%,-50%)'}}>
                <CardContent>
                  {Localization.strings.LOCALE_SEARCH_RESULT_NONE}
                </CardContent>
              </Card>
            </div>
          </Then>
          <Else>
            <If condition={this.props.parent.state.totalPage > 1}>
              <Then>
                <div style={{padding:"10px"}}>
                  {this.pageNavigator()}
                </div>
              </Then>
            </If>
            <Grid container style={{padding: '0 16px 0 16px'}}>
              {this.props.parent.state.localeList.map( (row, i) => {
                let editLocaleEnabled = (isAdminUser || (this.props.root.getSameSchoolEdit() && row['school_id'] == this.props.root.getMySchoolId()) || this.props.root.getMyUserId() == row['user_id']);
                let qaStateColor = blue[500];
                let qaState = row['qa_state'];
                if (qaState == 1) {
                  qaStateColor = green[500];
                }
                else if (qaState == 2) {
                  qaStateColor = amber[500];
                }
                else if (qaState == 3) {
                  qaStateColor = red[500];
                }

                return (
                  <Grid item key={i} xs={12} sm={6} md={4} lg={3} xl={2} style={{padding: 8}}>
                    <Card style={styles.card}>
                      <CardActionArea
                        // disabled={!editLocaleEnabled}
                        onClick={()=>this.overviewLocaleClicked(i)}
                      >
                        <CardMedia
                          style={styles.media}
                          image={ Config.UPLOAD_PATH() + row['tn_path'] }
                        />
                      </CardActionArea>
                        <CardContent>
                          <If condition={row['name'].length > 15 && row['name'].charCodeAt(row['name'].length/2) >=97 && row['name'].charCodeAt(row['name'].length/2) <=122 || 
                          row['name'].length >= 10 && !(row['name'].charCodeAt(row['name'].length/2) >=97 && row['name'].charCodeAt(row['name'].length/2) <=122)}>
                            <Then>
                              <ExpansionPanel elevation={0}>
                                  <ExpansionPanelSummary expandIcon={<Icon>keyboard_arrow_down</Icon>} style={{padding:"0"}}>
                                  <Typography gutterBottom variant="h5">
                                  <If condition = {row['name'].toLowerCase().charCodeAt(row['name'].length-1) >=97 && row['name'].toLowerCase().charCodeAt(row['name'].length-1) <=122 && row['name'].toLowerCase().charCodeAt(1) >=97 && row['name'].toLowerCase().charCodeAt(1) <=122 ||
                                  row['name'].toLowerCase().charCodeAt(row['name'].length-1) >=97 && row['name'].toLowerCase().charCodeAt(row['name'].length-1) <=122 && row['name'].toLowerCase().charCodeAt(0) >=97 && row['name'].toLowerCase().charCodeAt(0) <=122 || 
                                  row['name'].toLowerCase().charCodeAt(row['name'].length-2) >=97 && row['name'].toLowerCase().charCodeAt(row['name'].length-2) <=122 && row['name'].toLowerCase().charCodeAt(1) >=97 && row['name'].toLowerCase().charCodeAt(1) <=122 ||
                                  row['name'].toLowerCase().charCodeAt(row['name'].length-2) >=97 && row['name'].toLowerCase().charCodeAt(row['name'].length-2) <=122 && row['name'].toLowerCase().charCodeAt(0) >=97 && row['name'].toLowerCase().charCodeAt(0) <=122}>
                                    <Then>
                                      {row['name'].substring(0, 15) + " ..."}
                                    </Then>
                                    <Else>
                                      {row['name'].substring(0, 8) + " ..."}
                                    </Else>
                                  </If> 
                                  </Typography>
                                  </ExpansionPanelSummary>
                                  <ExpansionPanelDetails>
                                    {row['name']}
                                  </ExpansionPanelDetails>
                              </ExpansionPanel>
                            </Then>
                            <Else>
                            <ExpansionPanelSummary style={{pointerEvents:"none", right:"10px"}}>
                              <Typography gutterBottom variant="h5" style={{pointerevents:"none"}}>
                                {row['name']}
                              </Typography>
                              </ExpansionPanelSummary>
                            </Else>
                          </If>
                          <div style={{fontSize:'12px'}}>
                            <If condition={row['description'].length > 22}>
                             <Then>
                               <ExpansionPanel style={{bottom:"24px"}} elevation={0}>
                                 <ExpansionPanelSummary expandIcon={<Icon>keyboard_arrow_down</Icon>} style={{padding:"2px",left:"2px"}}>
                                 <If condition = {row['description'].toLowerCase().charCodeAt(1) >=97 && row['description'].toLowerCase().charCodeAt(1) <= 122}>
                                    <Then>
                                    {row['description'].substring(0, 25) + " ..."}
                                    </Then> 
                                    <Else>
                                      {row['description'].substring(0, 20) + " ..."}
                                    </Else>
                                </If>
                                 </ExpansionPanelSummary>
                                 <ExpansionPanelDetails>
                                   {row['description']}
                                 </ExpansionPanelDetails>
                               </ExpansionPanel>
                               <Divider style={{margin:"-24px 0 4px 0"}}/>
                             </Then>
                             <Else>
                              <ExpansionPanelSummary style={{pointerEvents:"none",right:"8px",bottom:"20px"}}>
                                {row['description']}
                              </ExpansionPanelSummary>
                              <Divider style={{margin:"-20px 0 4px 0"}}/>
                             </Else>
                           </If>
                         </div>
                          <div>
                            <Typography variant="caption">
                              {Localization.strings.KLA_FULL}: {(Localization.strings.getLanguage() === "en"? this.props.root.refs.userDataProfile.getKLAByID(row['kla']).name_eng : this.props.root.refs.userDataProfile.getKLAByID(row['kla']).name)}
                              <br/>
                              {Localization.strings.SUBJECT}:  {}
                              <If condition={row['subject'] == 0}>
                                <Then>
                                  {Localization.strings.UNSPECIFIED_SUBJECT}
                                </Then>
                                <Else>
                                  {(Localization.strings.getLanguage() === "en"? this.props.root.refs.userDataProfile.getSubjectByID(row['subject']).name_eng : this.props.root.refs.userDataProfile.getSubjectByID(row['subject']).name)}
                                </Else>
                              </If>
                              <br/>
                              <If condition={this.props.parent.state.isViewPublic}>
                                <Then>
                                  {Localization.strings.getLanguage() === "en" && row['school_name_eng'] !== "" ? row['school_name_eng'] : row['school_name']}
                                  <br/>
                                </Then>
                              </If>
                              {Localization.strings.AUTHOR}:
                              {isAdminUser? (" <" + row['id'] + "> " ) : ""}
                              {row['display_name']}
                              <br/>
                            </Typography>
                            <Typography variant="caption">
                              {Localization.strings.UPDATED_DATE}: {row['date_update']}
                              <br/>
                              {Localization.strings.CREATED_DATE}: {row['date_created']}
                            </Typography>
                          </div>
                        </CardContent>
                      <CardActions style={styles.actions} disableSpacing className="margin-zero padding-zero">
                      <div className="center">
                        <Tooltip
                          title={Localization.strings.EDIT_HOTSPOTS}
                          placement="bottom"
                        >
                          <span>
                            <IconButton onClick={()=>this.editLocaleClicked(i)} disabled={!editLocaleEnabled} className="margin-sm">
                              <Icon>edit</Icon>
                            </IconButton>
                          </span>
                        </Tooltip>
                        <Tooltip
                          title={Localization.strings.EXPLORE}
                          placement="bottom"
                        >
                          <span>
                            <IconButton onClick={()=>this.exploreLocaleClicked(i)} className="margin-sm">
                              <Icon>explore</Icon>
                            </IconButton>
                          </span>
                        </Tooltip>
                        <Tooltip
                          title={Localization.strings.VIEW_EDIT_DETAILS}
                          placement="bottom"
                        >
                          <span>
                            <IconButton onClick={()=>this.infoLocaleClicked(i)} disabled={!editLocaleEnabled} className="margin-sm">
                              <Icon>info</Icon>
                            </IconButton>
                          </span>
                        </Tooltip>
                        <Tooltip
                          title={Localization.strings.RETRIEVE_ANSWERS}
                          placement="bottom"
                        >
                          <span>
                            <IconButton onClick={()=>this.retrieveAnswerClicked(i)} className="margin-sm">
                              <If condition={row['submission_new_count'] > 0 && (isAdminUser || (this.props.root.getSameSchoolEdit() && row['school_id'] == this.props.root.getMySchoolId()) || this.props.root.getMyUserId() == row['user_id'])}>
                                <Then>
                                  <Badge color="secondary" badgeContent={row['submission_new_count']} max={99} 
                                    anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',}}>
                                    <Icon>assessment</Icon>
                                  </Badge>
                                </Then>
                                <Else>
                                  <Icon>assessment</Icon>
                                </Else>
                              </If>
                            </IconButton>
                          </span>
                        </Tooltip>
                        <Tooltip
                          title={Localization.strings.DELETE}
                          placement="bottom"
                        >
                          <span>
                            <IconButton onClick={()=>this.deleteLocaleClicked(row['id'])} disabled={!editLocaleEnabled} className="margin-sm">
                              <Icon>delete</Icon>
                            </IconButton>
                          </span>
                        </Tooltip>
                      </div>
                      </CardActions>
                      <If condition={isAdminUser}>
                        <Then>
                          <div style={{backgroundColor:qaStateColor, padding:'4px 0 0 0'}}></div>
                        </Then>
                      </If>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
            <If condition={this.props.parent.state.totalPage > 1}>
              <Then>
                <div style={{padding:"0 0 0 24px"}}>
                  {this.pageNavigator()}
                </div>
              </Then>
            </If>
          </Else>
        </If>
      </div>
    )
  }
}

export default LocaleListView;
